import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { ORG_SETUP_NEEDS_AUTH, ORG_SETUP_NEEDS_SYNC } from 'src/utils/authOrg.constants';
import Field from 'src/ConnectedComponents/fields/Field';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import LoadingDots from 'src/assets/loading_dots.svg';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import {
	fetchAppOrganizations,
	requestUpdateAppOrganization,
} from 'src/redux/appOrganizations/appOrganization.action';
import { getAppOrganizations } from 'src/redux/appOrganizations/appOrganization.selector';
import styles from '../../index.css';
import { Heading, HyperLink, Paragraph } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class ConnectDonorPerfect extends Component {
	state = { ready: false };

	async componentDidMount() {
		await this.props.fetchAppOrganizations();
		this.setState({ ready: true });
	}

	submitKey = async data => {
		if (data) {
			await this.props.requestUpdateAppOrganization(this.props.appOrganizations[0]._id, {
				donorperfect_api_key: data.api_key,
			});
			await this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
				setup_state: ORG_SETUP_NEEDS_SYNC,
			});
		}
	};

	render() {
		if (
			!this.state.ready ||
			this.props.authOrganizations.length === 0 ||
			this.props.appOrganizations.length === 0
		) {
			return <LoadingDots className={styles.SetupLoadingDots} />;
		}

		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== ORG_SETUP_NEEDS_AUTH) {
			return <Redirect to={{ pathname: '/' }} />;
		}

		return (
			<form className={styles.SetupCardLayout}>
				<Heading {...theme.heading.setUpTitle}>Connect DonorPerfect</Heading>
				<Paragraph>
					Let’s get Wisely connected and authorized with your DonorPerfect account.
				</Paragraph>
				<Field
					name="api_key"
					placeholder="Enter your DonorPerfect Online API Key"
					isRequired={true}
					component="input"
					type="password"
					className={styles.SetupInput}
				/>
				<Paragraph>
					You might need to contact the{' '}
					<HyperLink href="mailto:api@softerware.com">
						DonorPerfect API Help Desk
					</HyperLink>{' '}
					or request one through your regular DonorPerfect support channel.
				</Paragraph>
				<RoundedRectangleButton
					className={styles.DefaultButton}
					fontSize="16px"
					onClick={this.props.handleSubmit(this.submitKey)}
				>
					Continue
				</RoundedRectangleButton>
			</form>
		);
	}
}

ConnectDonorPerfect = reduxForm({
	form: 'donorperfect-api-key',
})(ConnectDonorPerfect);

const mapStateToProps = state => ({ appOrganizations: getAppOrganizations(state) });

export default connect(mapStateToProps, {
	fetchAppOrganizations,
	requestUpdateAppOrganization,
	requestUpdateAuthOrganization,
})(ConnectDonorPerfect);



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/ConnectCRM/ConnectDonorPerfect/index.js